const toggleSubMenuClass = (element, toggle) => {
  const parentElem = element.closest('.menu__item');
  parentElem?.classList.toggle('is-open-submenu', toggle);
};

// Toggle submenu on arrow click
attachEvent('.menu__arrow', 'click', (ev) => {
  const parentElem = ev.target.closest('.menu__item');
  if (!parentElem) return;

  const isOpen = parentElem.classList.contains('is-open-submenu');
  toggleSubMenuClass(parentElem, !isOpen);

  if (isOpen && windowWidth() >= breakpointMd) {
    parentElem.classList.add('is-closed');
    setTimeout(() => parentElem.classList.remove('is-closed'), 600);
  }
});

// Close submenu on ESC key press
onKeydown('Escape', () => {
  document.querySelectorAll('.menu__item.is-open-submenu').forEach((item) => toggleSubMenuClass(item, false));
});
